<!-- <div *ngIf="!fromLayout" class="mb-4">
    <img class="w-full" [src]="companyData?.design?.banner?.url ? companyData.design.banner.url : ''">
</div> -->
<div class="flex flex-col md:flex-row">
    <div class="hidden md:flex shop-layout__sidebar border-gray-300 rounded-sm border p-4  widget-logo widget me-6">
        <img class="w-full" style="object-fit: contain;" [src]="companyData?.design?.logo.url? companyData?.design?.logo.url : image">
    </div>
    <div class="block w-full" >
        <mat-tab-group>
            <mat-tab [label]="'about'|translate" *ngIf="companyData?.description">
            <div class="mt-2 p-2 leading-loose" [innerHTML]="translateHelper.localize(companyData?.description)"></div>
            </mat-tab>

            <mat-tab [label]="'business_policy'|translate" *ngIf="companyData?.policy">
                <div class="mt-2 px-2 leading-loose" [innerHTML]="translateHelper.localize(companyData?.policy)"></div>
            </mat-tab>

            <!-- <mat-tab *ngIf="companyData.shipmentMethodsData?.length > 0 || companyData.paymentMethodsData?.length > 0" label="Shipping and payment methods">
                <div class="mt-2 p-2 leading-loose" [innerHTML]="">Shipping and payment methods</div>
                <div class="flex flex-col sm:flex-row">
                    <div *ngIf="companyData.shipmentMethodsData?.length > 0" class="flex flex-col mx-3 w-1/2">
                        <div>Shipping Methods:</div>
                            <div *ngFor=""></div>
                    </div>

                    <mat-divider  *ngIf="companyData.shipmentMethodsData?.length > 0" [vertical]="true"></mat-divider>

                    <div *ngIf="companyData.paymentMethodsData?.length > 0" class="flex flex-col mx-3 w-1/2">
                        <div>Payment Methods:</div>
                            <ul>

                            <li *ngFor="let payment of companyData.paymentMethodsData">
                                    <div class="flex flex-row">
                                    <div class="">{{payment.name?.en}}</div>
                                </div>
                            </li></ul>
                    </div>
                </div>
            </mat-tab> -->

        </mat-tab-group>
    </div>
</div>
<!-- <button *ngIf="userDetails" class="mt-2 mb-2 btn btn-primary shop-layout__sidebar"  mat-button type="button" (click)="askVendor()" >{{"ask_vendor"|translate}}</button> -->